// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.posts_table_user{
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 10px;
    align-items: center;
}

.posts_userInformation_profil_img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
}
.posts_table_user p{
    padding: 0;
}

.posts_p{
    margin: 0;
}

.posts_list_title_component {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.posts_create_button {
    padding: 7px 20px;
    border-radius: 4px;
    background-color: var(--primary);
    border: solid 1px var(--primary);
    color: white;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/posts/PostList/postList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;IAChC,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".posts_table_user{\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    gap: 10px;\n    align-items: center;\n}\n\n.posts_userInformation_profil_img{\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-position: center;\n    background-size: cover;\n}\n.posts_table_user p{\n    padding: 0;\n}\n\n.posts_p{\n    margin: 0;\n}\n\n.posts_list_title_component {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.posts_create_button {\n    padding: 7px 20px;\n    border-radius: 4px;\n    background-color: var(--primary);\n    border: solid 1px var(--primary);\n    color: white;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
